import { environment } from 'src/environments/environment';

export const MARKET_AVAILABILITY_ENDPOINTS = {
  GET_AVAILABILITY_URL: `${environment.BACKEND_URL}api/engagement/market-closure`,
};
